import React, { memo } from 'react';
import { Ionicons, Fontisto, FontAwesome, FontAwesome5, MaterialIcons, MaterialCommunityIcons } from '@expo/vector-icons';
import IconMap from './IconMap';

export const ICON_TYPES = {
	ionicon: 'ionicon',
	fontAwesome5: 'fontAwesome5',
	fontisto: 'fontisto',
	materialIcons: 'materialIcons',
	materialCommunityIcons: 'materialCommunityIcons',
	fontAwesome: 'fontAwesome',
};

const Icon = ({
	icon,
	size,
	color,
}) => {
	const iconProps = {
		name: icon.name,
		size: size,
		color: color,
		testID: `${icon.name}Icon`,
		style: icon.style,
	};
	switch (icon.type) {
		case ICON_TYPES.ionicon: {
			return <Ionicons {...iconProps}/>;
		}
		case ICON_TYPES.fontisto: {
			return <Fontisto {...iconProps}/>;
		}
		case ICON_TYPES.fontAwesome: {
			return <FontAwesome {...iconProps}/>;
		}
		case ICON_TYPES.fontAwesome5: {
			return <FontAwesome5 {...iconProps}/>;
		}
		case ICON_TYPES.materialCommunityIcons: {
			return <MaterialCommunityIcons {...iconProps}/>;
		}
		case ICON_TYPES.materialIcons: {
			return <MaterialIcons {...iconProps}/>;
		}
		default:
			return <MaterialIcons {...iconProps} name={IconMap.broken.name}/>;
	}
};

export default memo(Icon);